import _objectWithoutProperties from "/Users/oct16/work/Cat/timecat-issue-helper/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Maintaining open source projects is hard work. As a free and open source project, TimeCat also has limited maintainer bandwidth. That means the only way to ensure the project's sustainability is to:"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "ol",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ol"
  }, "Prioritize more concrete work (bug fixes and new features);"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ol"
  }, "Improve issue triaging efficiency.")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "For (1), we have decided to use the GitHub issue lists exclusively for work that has well-defined, actionable goals. Questions and open ended discussions should be posted to mediums that are better suited for them."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "For (2), we have found that issues that do not provide proper information upfront usually results in terribly inefficient back-and-forth communication just to extract the basic information needed for actual triaging. This is exactly why we have created this app: to ensure that every issue is created with the necessary information, and to save time on both sides."));
});